import React from "react";

import "../../tokens/tokens.css";
import "./index.css";

/**
 * V2PageHeader — title + subtitle on the left, an optional action slot
 * (date selector, role pill, etc.) on the right. Purely presentational;
 * pages decide what the action slot renders.
 */
export default function V2PageHeader({ title, subtitle, action }) {
  return (
    <div className="v2-page-header">
      <div className="v2-page-header-text">
        <p className="v2-page-header-title">{title}</p>
        {subtitle && <p className="v2-page-header-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="v2-page-header-action">{action}</div>}
    </div>
  );
}
